import { chatEventEmitter } from '@wix/chat-sdk';
export var EVENT_TYPES = {
    EXPAND_CHAT_WIDGET: 'EXPAND_CHAT_WIDGET',
    COLLAPSE_CHAT_WIDGET: 'COLLAPSE_CHAT_WIDGET',
};
var ExpandCollapseManager = /** @class */ (function () {
    function ExpandCollapseManager() {
    }
    ExpandCollapseManager.prototype.unregisterOnExpand = function (handler) {
        chatEventEmitter.removeListener(EVENT_TYPES.EXPAND_CHAT_WIDGET, handler);
    };
    ExpandCollapseManager.prototype.unregisterOnCollapse = function (handler) {
        chatEventEmitter.removeListener(EVENT_TYPES.COLLAPSE_CHAT_WIDGET, handler);
    };
    ExpandCollapseManager.prototype.registerOnExpand = function (handler) {
        chatEventEmitter.addListener(EVENT_TYPES.EXPAND_CHAT_WIDGET, handler);
    };
    ExpandCollapseManager.prototype.registerOnCollapse = function (handler) {
        chatEventEmitter.addListener(EVENT_TYPES.COLLAPSE_CHAT_WIDGET, handler);
    };
    ExpandCollapseManager.prototype.expand = function (data) {
        if (data === void 0) { data = {}; }
        chatEventEmitter.emit(EVENT_TYPES.EXPAND_CHAT_WIDGET, data);
    };
    ExpandCollapseManager.prototype.collapse = function (data) {
        if (data === void 0) { data = {}; }
        chatEventEmitter.emit(EVENT_TYPES.COLLAPSE_CHAT_WIDGET, data);
    };
    return ExpandCollapseManager;
}());
export var expandCollapseManager = new ExpandCollapseManager();
//# sourceMappingURL=expand-collapse-manager.js.map